import React, { forwardRef } from "react";
import styled from "@emotion/styled";
import * as SwitchPrimitive from "@radix-ui/react-switch";

const Root = styled(SwitchPrimitive.Root)(({ theme }) => ({
  all: "unset",
  width: 44,
  height: 22,
  borderRadius: 64,
  display: "inline-flex",
  alignItems: "center",
  position: "relative",
  boxSizing: "border-box",
  cursor: "pointer",
  backgroundColor: theme.colors.grey300,
  transition: "background-color 0.2s ease",

  "&[data-state=checked]": {
    backgroundColor: theme.colors.sysPrimaryDefault,
  },

  "&:focus-visible": {
    outline: `2px solid ${theme.colors.sysPrimarySubtleAlt}`,
    outlineOffset: 2,
  },

  "&:disabled": {
    cursor: "not-allowed",
    backgroundColor: theme.colors.grey100,
  },

  "&:disabled[data-state=checked]": {
    backgroundColor: theme.colors.blue200,
  },
}));

const Thumb = styled(SwitchPrimitive.Thumb)(({ theme }) => ({
  width: 18,
  height: 18,
  borderRadius: "50%",
  backgroundColor: theme.colors.sysBackgroundDefault,
  transform: "translateX(2px)",
  willChange: "transform",
  transition: "transform 0.2s ease",

  "&[data-state=checked]": {
    transform: "translateX(24px)",
  },
}));

const Toggle = forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>((props, ref) => (
  <Root ref={ref} {...props}>
    <Thumb />
  </Root>
));

Toggle.displayName = SwitchPrimitive.Root.displayName;

export default Toggle;
